const { PIL_JUICY_SCORE_API_KEY, PIL_JUICY_SCORE_SCRIPT_URL } = process.env;

const juicyScoreConfigScript = `<script async type="text/javascript">
    var juicyLabConfig = {
        nextButton: ".juicyScoreNextButton",
        completeButton: ".juicyScoreCompleteButton",
        apiKey: "${PIL_JUICY_SCORE_API_KEY}",
    };
</script>`;

const juicyScoreMainScript = `<script type="text/javascript">
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = "${PIL_JUICY_SCORE_SCRIPT_URL}";
    var x = document.getElementsByTagName('head')[0];
    x.appendChild(s);
</script>
<noscript>
    <img style="display:none;" src="https://score.juicyscore.com/savedata/?isJs=0" />
</noscript>`;

module.exports = {
    juicyScoreConfigScript,
    juicyScoreMainScript
};
